import {useEffect, useRef, DependencyList, EffectCallback} from 'react';

export function useUpdateEffect(effect: EffectCallback, deps: DependencyList = []) {
    const isInit = useRef(true);

    useEffect(
        () => {
            if (isInit.current === true) {
                isInit.current = false;
                return;
            }
            return effect();
        },

        deps,
    );
}
